import * as React from 'react';
import { useImperativeHandle } from 'react';

import { UseQrCodeParams, useQrCode } from './useQrCode';

export interface Props extends UseQrCodeParams {
  ['data-testid']?: string;
}

export const QrCode = React.forwardRef<HTMLCanvasElement, Props>(
  function QrCode(
    {
      text,
      background = '#FFFFFF',
      radius = 1, // Bit of radius so the qr code doesn't look excessively sharp
      fill = '#000000',
      size,
      ...props
    }: Props,
    ref
  ) {
    const { refCallback, canvasRef } = useQrCode({
      fill,
      size,
      text,
      background,
      radius,
    });

    useImperativeHandle(ref, () => canvasRef.current);

    return <canvas ref={refCallback} data-testid={props['data-testid']} />;
  }
);
